export default __webpack_public_path__ + "static/media/baby_blue.5af1afc1.png";